import { Component, HostBinding, HostListener, Input, OnDestroy } from "@angular/core";
import { appAnimations } from "src/app/core/animations";

@Component({
    selector: 'app-nav-horizontal-collapse',
    templateUrl: './nav-horizontal-collapse.component.html',
    styleUrls: ['./nav-horizontal-collapse.component.scss'],
    animations: appAnimations
})
export class NavHorizontalCollapseComponent
{
    public isOpen = false;

    @HostBinding('class') classes = 'nav-item nav-collapse';
    @Input() item: any;

    @HostListener('mouseenter')
    open()
    {
        this.isOpen = true;
    }

    @HostListener('mouseleave')
    close()
    {
        this.isOpen = false;
    }
}